import React from 'react';
import { Link } from 'react-router-dom';
import './TeamsOverview.css';

const teams = [
  { name: 'A-team', logo: 'img/Team logo/A-team-uten-tekst.png' },
  { name: 'Angry nerds', logo: 'img/Team logo/Angry-nerds-uten-tekst.png' },
  { name: 'Astro', logo: 'img/Team logo/Astro-uten-tekst.png' },
  { name: 'Beehive', logo: 'img/Team logo/Beehive-uten-tekst.png' },
  { name: 'Bond', logo: 'img/Team logo/Bond-uten-tekst.png' },
  { name: 'Eagle', logo: 'img/Team logo/Eagle-uten-tekst.png' },
  { name: 'Goldshark', logo: 'img/Team logo/Goldshark-uten-tekst.png' },
  { name: 'KillBill', logo: 'img/Team logo/KillBill-uten-tekst.png' },
  { name: 'KRR', logo: 'img/Team logo/KRR-uten-tekst.png' },
  { name: 'Optimus', logo: 'img/Team logo/Optimus-uten-tekst.png' },
  { name: 'Phoenix', logo: 'img/Team logo/Phoenix-uten-tekst.png' },
  { name: 'Piggy Bank Crew', logo: 'img/Team logo/PBC-uten-tekst.png' },
  { name: 'PT', logo: 'img/Team logo/PT-uten-tekst.png' },
  { name: 'Relions', logo: 'img/Team logo/Relions.png' },
  { name: 'Sheet Storm', logo: 'img/Team logo/SheetStorm-uten-tekst.png' },
  { name: 'Task Fox', logo: 'img/Team logo/taskfox.png' },
  { name: 'Time Travellers', logo: 'img/Team logo/time-travellers2.png' },
  { name: 'TSK', logo: 'img/Team logo/TSK-uten-tekst.png' },
  
];

function TeamsOverview() {
  return (
    <div id="our-teams" className="fh5co-features-outer blue20-background">
      <div className="container">
        <h1>Our teams</h1>
        <div className="row justify-content-center description our-teams">
          {teams.map((team, index) => (
            <div key={index} className="col-sm-3 fadeIn animated" data-wow-delay="0.25s">
              <Link to={`/teams/${team.name.toLowerCase().replaceAll(' ', '-')}`} className="team-link">
                <div className="team-container">
                  <img 
                    className="playbook-team"
                    src={team.logo} 
                    alt={team.name} 
                  />
                  <label className="team-label">{team.name}</label>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TeamsOverview;
